export default {
  EN: 'en',
  HE: 'he',
  BR: 'br',
  DE: 'de',
};
